import styles from './AddQuiz.module.scss';
import Modal from 'src/components/modal/Modal';
import Button from 'src/components/button/Button';
import { TextInput, TextInputValue } from 'src/components/text-input/TextInput';
import { useCallback, useEffect, useMemo, useState } from 'react';
import Spinner from '@src/components/spinner/Spinner';
import { QuizFragment } from '@src/api/graphql-codegen';
import { SelectOption } from '@src/types';
import Select from '@src/components/select/Select';

type Props = {
  open: boolean;
  creating: boolean;
  quizzes: QuizFragment[];
  onClose: () => void;
  onCreateNew: (name: string) => void;
  onAddLessonToCourse?: (id: string) => void;
  coursesForSelectedLessonIds: string[];
};

function AddCourse(props: Props) {
  const { open, creating, quizzes, coursesForSelectedLessonIds, onClose, onCreateNew, onAddLessonToCourse} = props;
  const [ name, setName ] = useState("")
  const [ error, setError ] = useState("")
  const [ collection, setCollection ] = useState('')

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    const onPageLoad = () => {
      const item = document.getElementById("name")
      if (item) {
        item.focus();
      }
    };
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
      return () => window.removeEventListener('load', onPageLoad);
    }

  }, [])

  const handleChange = (value: TextInputValue) => {
    setName(value.toString())
    setError('')
  }
  const handleCreateNew = useCallback(() => {
    if (name) {
      const exist = quizzes.find(plan => plan.name.toLocaleLowerCase() === name.toLocaleLowerCase())
      if (exist) {
        setError(`${name} is exist already, Assessment name should be unique.`)
        return;
      }
      onCreateNew(name)
    } else if (collection) {
      onAddLessonToCourse?.(collection)
    }
  }, [name, quizzes, collection, onCreateNew, onAddLessonToCourse])

  const onChangeCollection = useCallback((o: SelectOption) => {
    setCollection(o.value);
  }, []);

  const existingCollections = useMemo(() => (quizzes || []).filter(course => !coursesForSelectedLessonIds.includes(course.id)).map(course => ({
    value: course.id,
    label: course.name,
  })), [quizzes, coursesForSelectedLessonIds]);

  return (
    <Modal open={open} onClose={handleClose} className={styles.wrapper}>
      <div>
        <div className={styles.title}>Name your new Assessment:</div>
        <div className={styles.content}>
          <TextInput hasError={error!==''} subTitle={error} id="name" placeholder={'Assessment Name'} value={name} label={''} onChange={handleChange} />
          {quizzes?.length > 0 && onAddLessonToCourse ? (
            <div className={styles.collectionSelect}>
              <Select
                inDropDown={true}
                value={collection}
                onChange={onChangeCollection}
                label={'Or add to existing Collection:'}
                options={existingCollections}
                showSearch={false}
                disabled={creating || !!name}
                menuClassName={styles.selectorStyle}
              />
            </div>
          ) : null}
          <div className={styles.action}>
            <Button disabled={creating || (!collection && !name)} leftIcon={creating ? <Spinner width={20} height={20} /> : undefined} className={styles.okButton} onClick={handleCreateNew} label={'SAVE'}/>
          </div>
        </div>        
      </div>
    </Modal>
  );
}

export default AddCourse;
